
import { FC } from "react";
import { Message as MessageType } from "@/utils/frankMessageUtils";
import SourcesSection from "./SourcesSection";
import MessageContent from "./MessageContent";
import FrankAvatar from "./FrankAvatar";
import UserAvatar from "./UserAvatar";

interface MessageProps {
  message: MessageType;
  formatTime: (date: Date) => string;
  member?: {
    full_name: string;
    profile_picture_url?: string;
  } | null;
}

const Message: FC<MessageProps> = ({ message, formatTime, member }) => {
  const hasSourceInfo = message.sources && Array.isArray(message.sources) && message.sources.length > 0;
  
  if (message.sender === "frank") {
    console.log("Rendering message with sources:", JSON.stringify(message.sources, null, 2));
  }
  
  if (message.sender === "user") {
    return (
      <div className="flex items-end gap-3 justify-end">
        <div className="flex flex-1 flex-col gap-1 items-end">
          <p className="text-[#637588] text-[13px] font-normal max-w-[360px] text-right">
            {member?.full_name || "You"}
          </p>
          <div className="text-base font-normal leading-normal flex max-w-[360px] rounded-lg px-4 py-3 bg-[#2F80ED] text-white">
            <MessageContent text={message.text} />
          </div>
          <p className="text-[#637588] text-[11px] font-normal mt-1 text-right">
            {formatTime(message.timestamp)}
          </p>
        </div>
        <UserAvatar
          fullName={member?.full_name}
          profilePictureUrl={member?.profile_picture_url}
        />
      </div>
    );
  }

  return (
    <div className="flex items-end gap-3">
      <FrankAvatar className="shrink-0" />
      <div className="flex flex-1 flex-col gap-1 items-start">
        <p className="text-[#637588] text-[13px] font-normal max-w-[360px]">Frank</p>
        <div className="text-base font-normal leading-normal flex flex-col max-w-[360px] rounded-lg px-4 py-3 bg-[#f0f2f4] text-[#111418]">
          <MessageContent text={message.text} isMarkdown={true} />
          
          {hasSourceInfo && (
            <SourcesSection sources={message.sources!} />
          )}
        </div>
        <p className="text-[#637588] text-[11px] font-normal mt-1">
          {formatTime(message.timestamp)}
        </p>
      </div>
    </div>
  );
};

export default Message;
